
import { Collection } from "@/lib/api/types";
import { format } from "date-fns";

interface CollectionInfoProps {
  collection: Collection;
}

export const CollectionInfo = ({ collection }: CollectionInfoProps) => {
  return (
    <div className="space-y-2 w-full">
      <h3 className="text-lg font-semibold tracking-tight">{collection.name}</h3>
      {collection.description && (
        <p className="text-sm text-muted-foreground line-clamp-2">
          {collection.description}
        </p>
      )}
      {collection.created_at && (
        <p className="text-xs text-muted-foreground/80">
          Created {format(new Date(collection.created_at), 'MMM d, yyyy')}
        </p>
      )}
    </div>
  );
};
